// @generated by protoc-gen-es v2.9.0 with parameter "target=dts+js,js_import_style=legacy_commonjs"
// @generated from file stailer_service_specification/shop/v1/shop.proto (package stailer_service_specification.shop.v1, syntax proto3)
/* eslint-disable */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });

const { fileDesc, messageDesc } = require("@bufbuild/protobuf/codegenv2");
const { file_description_support_v1_field_description } = require("../../../description_support/v1/field_description_pb");
const { file_stailer_service_specification_shop_v1_receive_method } = require("./receive_method_pb");

/**
 * Describes the file stailer_service_specification/shop/v1/shop.proto.
 */
const file_stailer_service_specification_shop_v1_shop = /*@__PURE__*/
  fileDesc("CjBzdGFpbGVyX3NlcnZpY2Vfc3BlY2lmaWNhdGlvbi9zaG9wL3YxL3Nob3AucHJvdG8SJXN0YWlsZXJfc2VydmljZV9zcGVjaWZpY2F0aW9uLnNob3AudjEi7QEKBFNob3AS5AEKGGF2YWlsYWJsZV9yZWNlaXZlX21ldGhvZBgBIAEoCzI0LnN0YWlsZXJfc2VydmljZV9zcGVjaWZpY2F0aW9uLnNob3AudjEuUmVjZWl2ZU1ldGhvZEKLAZKCGVrlupfoiJfjgafoqK3lrprlj6/og73jgarlj5fjgZHlj5bjgormlrnlvI/jgajlkITjgqrjg5fjgrfjg6fjg7Pjga7jgrXjg7zjg5Pjgrnku5Xmp5jjgafjgZmqghkh6Kit5a6a5Y+v6IO944Gq5Y+X44GR5Y+W44KK5pa55byPuIIZAsCCGQFiBnByb3RvMw", [file_description_support_v1_field_description, file_stailer_service_specification_shop_v1_receive_method]);

/**
 * Describes the message stailer_service_specification.shop.v1.Shop.
 * Use `create(ShopSchema)` to create a new message.
 */
const ShopSchema = /*@__PURE__*/
  messageDesc(file_stailer_service_specification_shop_v1_shop, 0);


exports.file_stailer_service_specification_shop_v1_shop = file_stailer_service_specification_shop_v1_shop;
exports.ShopSchema = ShopSchema;
